






























import { Component, Vue, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import PageInitialMixin from "@/mixins/PageInitialMixin";
import { Section } from "@/common/interface";
import store from "@/store";
import getUrlParam from "@/common/utils/getUrlParam";

@Component
export default class GachaTabs extends Vue {
  @Getter("gachaTypeParameter") gachaParameter!: object;
  type: string = getUrlParam("type") as string;

  get gachaTypeParameter() {
    return this.gachaParameter;
  }
  get sectionConf() {
    return store.getters.section;
  }

  toggleGachaType(targetType:string) {
    if(this.type === "reEdit" ){
      return
    }
    store.dispatch("toggleGachaType",targetType);
  }
}
